<div class="flex flex-column gap-2 mb-4">
  <label for="move_select_tree">
    <ng-container i18n="@@prompt_move_dialog_destination">Destination</ng-container>
  </label>
  <p-treeSelect
    class="no-outline"
    inputId="move_select_tree"
    containerStyleClass="w-full"
    [(ngModel)]="selectedNode"
    [options]="savedNodes"
    [filter]="true"
    appendTo="body"
  >
    <ng-template
      pTemplate="default"
      let-node
      [ngAs]="PromptNode"
    >
      <div>
        <div class="flex gap-3 align-items-center justify-content-between line">
          <b>{{ node.label }}</b>
        </div>
      </div>
    </ng-template>
  </p-treeSelect>
</div>

<div class="flex gap-2 justify-content-end">
  <button
    class="p-button-primary"
    (click)="move()"
    [disabled]="!selectedNode"
    pButton
    type="button"
  >
    <ng-container i18n="@@prompt_move_dialog_save_button_label">Sauvegarder</ng-container>
  </button>
  <button
    class="p-button-warning"
    (click)="ref.close()"
    pButton
    type="button"
  >
    <ng-container i18n="@@prompt_move_dialog_cancel_button_label">Annuler</ng-container>
  </button>
</div>
